// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */
@font-face {
  font-family: "swiper-icons";
  src: url("data:application/font-woff;charset=utf-8;base64, d09GRgABAAAAAAZgABAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAAGRAAAABoAAAAci6qHkUdERUYAAAWgAAAAIwAAACQAYABXR1BPUwAABhQAAAAuAAAANuAY7+xHU1VCAAAFxAAAAFAAAABm2fPczU9TLzIAAAHcAAAASgAAAGBP9V5RY21hcAAAAkQAAACIAAABYt6F0cBjdnQgAAACzAAAAAQAAAAEABEBRGdhc3AAAAWYAAAACAAAAAj//wADZ2x5ZgAAAywAAADMAAAD2MHtryVoZWFkAAABbAAAADAAAAA2E2+eoWhoZWEAAAGcAAAAHwAAACQC9gDzaG10eAAAAigAAAAZAAAArgJkABFsb2NhAAAC0AAAAFoAAABaFQAUGG1heHAAAAG8AAAAHwAAACAAcABAbmFtZQAAA/gAAAE5AAACXvFdBwlwb3N0AAAFNAAAAGIAAACE5s74hXjaY2BkYGAAYpf5Hu/j+W2+MnAzMYDAzaX6QjD6/4//Bxj5GA8AuRwMYGkAPywL13jaY2BkYGA88P8Agx4j+/8fQDYfA1AEBWgDAIB2BOoAeNpjYGRgYNBh4GdgYgABEMnIABJzYNADCQAACWgAsQB42mNgYfzCOIGBlYGB0YcxjYGBwR1Kf2WQZGhhYGBiYGVmgAFGBiQQkOaawtDAoMBQxXjg/wEGPcYDDA4wNUA2CCgwsAAAO4EL6gAAeNpj2M0gyAACqxgGNWBkZ2D4/wMA+xkDdgAAAHjaY2BgYGaAYBkGRgYQiAHyGMF8FgYHIM3DwMHABGQrMOgyWDLEM1T9/w8UBfEMgLzE////P/5//f/V/xv+r4eaAAeMbAxwIUYmIMHEgKYAYjUcsDAwsLKxc3BycfPw8jEQA/gZBASFhEVExcQlJKWkZWTl5BUUlZRVVNXUNTQZBgMAAMR+E+gAEQFEAAAAKgAqACoANAA+AEgAUgBcAGYAcAB6AIQAjgCYAKIArAC2AMAAygDUAN4A6ADyAPwBBgEQARoBJAEuATgBQgFMAVYBYAFqAXQBfgGIAZIBnAGmAbIBzgHsAAB42u2NMQ6CUAyGW568x9AneYYgm4MJbhKFaExIOAVX8ApewSt4Bic4AfeAid3VOBixDxfPYEza5O+Xfi04YADggiUIULCuEJK8VhO4bSvpdnktHI5QCYtdi2sl8ZnXaHlqUrNKzdKcT8cjlq+rwZSvIVczNiezsfnP/uznmfPFBNODM2K7MTQ45YEAZqGP81AmGGcF3iPqOop0r1SPTaTbVkfUe4HXj97wYE+yNwWYxwWu4v1ugWHgo3S1XdZEVqWM7ET0cfnLGxWfkgR42o2PvWrDMBSFj/IHLaF0zKjRgdiVMwScNRAoWUoH78Y2icB/yIY09An6AH2Bdu/UB+yxopYshQiEvnvu0dURgDt8QeC8PDw7Fpji3fEA4z/PEJ6YOB5hKh4dj3EvXhxPqH/SKUY3rJ7srZ4FZnh1PMAtPhwP6fl2PMJMPDgeQ4rY8YT6Gzao0eAEA409DuggmTnFnOcSCiEiLMgxCiTI6Cq5DZUd3Qmp10vO0LaLTd2cjN4fOumlc7lUYbSQcZFkutRG7g6JKZKy0RmdLY680CDnEJ+UMkpFFe1RN7nxdVpXrC4aTtnaurOnYercZg2YVmLN/d/gczfEimrE/fs/bOuq29Zmn8tloORaXgZgGa78yO9/cnXm2BpaGvq25Dv9S4E9+5SIc9PqupJKhYFSSl47+Qcr1mYNAAAAeNptw0cKwkAAAMDZJA8Q7OUJvkLsPfZ6zFVERPy8qHh2YER+3i/BP83vIBLLySsoKimrqKqpa2hp6+jq6RsYGhmbmJqZSy0sraxtbO3sHRydnEMU4uR6yx7JJXveP7WrDycAAAAAAAH//wACeNpjYGRgYOABYhkgZgJCZgZNBkYGLQZtIJsFLMYAAAw3ALgAeNolizEKgDAQBCchRbC2sFER0YD6qVQiBCv/H9ezGI6Z5XBAw8CBK/m5iQQVauVbXLnOrMZv2oLdKFa8Pjuru2hJzGabmOSLzNMzvutpB3N42mNgZGBg4GKQYzBhYMxJLMlj4GBgAYow/P/PAJJhLM6sSoWKfWCAAwDAjgbRAAB42mNgYGBkAIIbCZo5IPrmUn0hGA0AO8EFTQAA") format("woff");
  font-weight: 400;
  font-style: normal;
}
:root {
  --swiper-theme-color: #007aff;
}

.swiper {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  /* Fix of Webkit flickering */
  z-index: 1;
}

.swiper-vertical > .swiper-wrapper {
  flex-direction: column;
}

.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
}

.swiper-android .swiper-slide,
.swiper-wrapper {
  transform: translate3d(0px, 0, 0);
}

.swiper-pointer-events {
  touch-action: pan-y;
}
.swiper-pointer-events.swiper-vertical {
  touch-action: pan-x;
}

.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
}

.swiper-slide-invisible-blank {
  visibility: hidden;
}

/* Auto Height */
.swiper-autoheight,
.swiper-autoheight .swiper-slide {
  height: auto;
}
.swiper-autoheight .swiper-wrapper {
  align-items: flex-start;
  transition-property: transform, height;
}

.swiper-backface-hidden .swiper-slide {
  transform: translateZ(0);
  backface-visibility: hidden;
}

/* 3D Effects */
.swiper-3d, .swiper-3d.swiper-css-mode .swiper-wrapper {
  perspective: 1200px;
}
.swiper-3d .swiper-wrapper,
.swiper-3d .swiper-slide,
.swiper-3d .swiper-slide-shadow,
.swiper-3d .swiper-slide-shadow-left,
.swiper-3d .swiper-slide-shadow-right,
.swiper-3d .swiper-slide-shadow-top,
.swiper-3d .swiper-slide-shadow-bottom,
.swiper-3d .swiper-cube-shadow {
  transform-style: preserve-3d;
}
.swiper-3d .swiper-slide-shadow,
.swiper-3d .swiper-slide-shadow-left,
.swiper-3d .swiper-slide-shadow-right,
.swiper-3d .swiper-slide-shadow-top,
.swiper-3d .swiper-slide-shadow-bottom {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
}
.swiper-3d .swiper-slide-shadow {
  background: rgba(0, 0, 0, 0.15);
}
.swiper-3d .swiper-slide-shadow-left {
  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}
.swiper-3d .swiper-slide-shadow-right {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}
.swiper-3d .swiper-slide-shadow-top {
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}
.swiper-3d .swiper-slide-shadow-bottom {
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

/* CSS Mode */
.swiper-css-mode > .swiper-wrapper {
  overflow: auto;
  scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none; /* For Internet Explorer and Edge */
}
.swiper-css-mode > .swiper-wrapper::-webkit-scrollbar {
  display: none;
}
.swiper-css-mode > .swiper-wrapper > .swiper-slide {
  scroll-snap-align: start start;
}

.swiper-horizontal.swiper-css-mode > .swiper-wrapper {
  scroll-snap-type: x mandatory;
}

.swiper-vertical.swiper-css-mode > .swiper-wrapper {
  scroll-snap-type: y mandatory;
}

.swiper-centered > .swiper-wrapper::before {
  content: "";
  flex-shrink: 0;
  order: 9999;
}
.swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-child {
  margin-inline-start: var(--swiper-centered-offset-before);
}
.swiper-centered.swiper-horizontal > .swiper-wrapper::before {
  height: 100%;
  width: var(--swiper-centered-offset-after);
}
.swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-child {
  margin-block-start: var(--swiper-centered-offset-before);
}
.swiper-centered.swiper-vertical > .swiper-wrapper::before {
  width: 100%;
  height: var(--swiper-centered-offset-after);
}
.swiper-centered > .swiper-wrapper > .swiper-slide {
  scroll-snap-align: center center;
  scroll-snap-stop: always;
}

:root {
  --swiper-navigation-size: 44px;
  /*
  --swiper-navigation-color: var(--swiper-theme-color);
  */
}

.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50%;
  width: calc(var(--swiper-navigation-size) / 44 * 27);
  height: var(--swiper-navigation-size);
  margin-top: calc(0px - var(--swiper-navigation-size) / 2);
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--swiper-navigation-color, var(--swiper-theme-color));
}
.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  opacity: 0.35;
  cursor: auto;
  pointer-events: none;
}
.swiper-button-prev.swiper-button-hidden,
.swiper-button-next.swiper-button-hidden {
  opacity: 0;
  cursor: auto;
  pointer-events: none;
}
.swiper-navigation-disabled .swiper-button-prev,
.swiper-navigation-disabled .swiper-button-next {
  display: none !important;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-family: swiper-icons;
  font-size: var(--swiper-navigation-size);
  text-transform: none !important;
  letter-spacing: 0;
  font-variant: initial;
  line-height: 1;
}

.swiper-button-prev,
.swiper-rtl .swiper-button-next {
  left: 10px;
  right: auto;
}
.swiper-button-prev:after,
.swiper-rtl .swiper-button-next:after {
  content: "prev";
}

.swiper-button-next,
.swiper-rtl .swiper-button-prev {
  right: 10px;
  left: auto;
}
.swiper-button-next:after,
.swiper-rtl .swiper-button-prev:after {
  content: "next";
}

.swiper-button-lock {
  display: none;
}

:root {
  /*
  --swiper-pagination-color: var(--swiper-theme-color);
  --swiper-pagination-bullet-size: 8px;
  --swiper-pagination-bullet-width: 8px;
  --swiper-pagination-bullet-height: 8px;
  --swiper-pagination-bullet-inactive-color: #000;
  --swiper-pagination-bullet-inactive-opacity: 0.2;
  --swiper-pagination-bullet-opacity: 1;
  --swiper-pagination-bullet-horizontal-gap: 4px;
  --swiper-pagination-bullet-vertical-gap: 6px;
  */
}

.swiper-pagination {
  position: absolute;
  text-align: center;
  transition: 300ms opacity;
  transform: translate3d(0, 0, 0);
  z-index: 10;
}
.swiper-pagination.swiper-pagination-hidden {
  opacity: 0;
}
.swiper-pagination-disabled > .swiper-pagination, .swiper-pagination.swiper-pagination-disabled {
  display: none !important;
}

/* Common Styles */
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-horizontal > .swiper-pagination-bullets,
.swiper-pagination-bullets.swiper-pagination-horizontal {
  bottom: 10px;
  left: 0;
  width: 100%;
}

/* Bullets */
.swiper-pagination-bullets-dynamic {
  overflow: hidden;
  font-size: 0;
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transform: scale(0.33);
  position: relative;
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
  transform: scale(1);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
  transform: scale(1);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
  transform: scale(0.66);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
  transform: scale(0.33);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
  transform: scale(0.66);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
  transform: scale(0.33);
}

.swiper-pagination-bullet {
  width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));
  height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));
  display: inline-block;
  border-radius: 50%;
  background: var(--swiper-pagination-bullet-inactive-color, #000);
  opacity: var(--swiper-pagination-bullet-inactive-opacity, 0.2);
}
button.swiper-pagination-bullet {
  border: none;
  margin: 0;
  padding: 0;
  box-shadow: none;
  appearance: none;
}

.swiper-pagination-clickable .swiper-pagination-bullet {
  cursor: pointer;
}
.swiper-pagination-bullet:only-child {
  display: none !important;
}

.swiper-pagination-bullet-active {
  opacity: var(--swiper-pagination-bullet-opacity, 1);
  background: var(--swiper-pagination-color, var(--swiper-theme-color));
}

.swiper-vertical > .swiper-pagination-bullets,
.swiper-pagination-vertical.swiper-pagination-bullets {
  right: 10px;
  top: 50%;
  transform: translate3d(0px, -50%, 0);
}
.swiper-vertical > .swiper-pagination-bullets .swiper-pagination-bullet,
.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet {
  margin: var(--swiper-pagination-bullet-vertical-gap, 6px) 0;
  display: block;
}
.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
}
.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  display: inline-block;
  transition: 200ms transform, 200ms top;
}

.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px);
}
.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}
.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transition: 200ms transform, 200ms left;
}

.swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transition: 200ms transform, 200ms right;
}

/* Progress */
.swiper-pagination-progressbar {
  background: rgba(0, 0, 0, 0.25);
  position: absolute;
}
.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background: var(--swiper-pagination-color, var(--swiper-theme-color));
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transform: scale(0);
  transform-origin: left top;
}
.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  transform-origin: right top;
}
.swiper-horizontal > .swiper-pagination-progressbar, .swiper-pagination-progressbar.swiper-pagination-horizontal, .swiper-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite, .swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite {
  width: 100%;
  height: 4px;
  left: 0;
  top: 0;
}
.swiper-vertical > .swiper-pagination-progressbar, .swiper-pagination-progressbar.swiper-pagination-vertical, .swiper-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite, .swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite {
  width: 4px;
  height: 100%;
  left: 0;
  top: 0;
}

.swiper-pagination-lock {
  display: none;
}

.line-filter {
  text-align: center;
  line-height: 20px;
  background: #70c2d1;
  padding: 0;
  margin: 0;
}

.name-client {
  font-size: 0.9em;
  max-width: 12em;
  padding: 0;
}

ion-searchbar {
  --icon-color: #1ca3c9;
  width: 95%;
  margin-left: 10px;
}

.search-container {
  width: 90vw;
  right: 5vw;
  height: auto;
  max-height: 50vh;
  overflow-y: scroll;
  position: absolute;
}

menu-text {
  font-size: 2em;
}

ion-menu ion-content {
  --background: var(--ion-item-background, var(--ion-background-color, #fff));
}

ion-menu.md ion-content {
  --padding-start: 8px;
  --padding-end: 8px;
  --padding-top: 20px;
  --padding-bottom: 20px;
}

ion-menu.md ion-list {
  padding: 20px 0;
}

ion-menu.md ion-note {
  margin-bottom: 30px;
}

ion-menu.md ion-list-header,
ion-menu.md ion-note {
  padding-left: 10px;
}

ion-menu.md ion-list#inbox-list {
  border-bottom: 1px solid var(--ion-color-step-150, #d7d8da);
}

ion-menu.md ion-list#inbox-list ion-list-header {
  font-size: 22px;
  font-weight: 600;
  min-height: 20px;
}

ion-menu.md ion-list#labels-list ion-list-header {
  font-size: 16px;
  margin-bottom: 18px;
  color: #757575;
  min-height: 26px;
}

ion-menu.md ion-item {
  --padding-start: 10px;
  --padding-end: 10px;
  border-radius: 4px;
}

ion-menu.md ion-item.selected {
  --background: rgba(var(--ion-color-primary-rgb), 0.14);
}

ion-menu.md ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}

ion-menu.md ion-item ion-icon h6 {
  color: #616e7e;
}

ion-menu.md ion-item ion-label {
  font-weight: 500;
}

ion-menu.ios ion-content {
  --padding-bottom: 20px;
}

ion-menu.ios ion-list {
  padding: 20px 0 0 0;
}

ion-menu.ios ion-note {
  line-height: 24px;
  margin-bottom: 20px;
}

ion-menu.ios ion-item {
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 50px;
}

ion-menu.ios ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}

ion-menu.ios ion-item ion-icon {
  font-size: 24px;
  color: #73849a;
}

ion-menu.ios ion-list#labels-list ion-list-header {
  margin-bottom: 8px;
}

ion-menu.ios ion-list-header,
ion-menu.ios ion-note {
  padding-left: 16px;
  padding-right: 16px;
}

ion-menu.ios ion-note {
  margin-bottom: 8px;
}

ion-item.selected {
  --color: var(--ion-color-primary);
}

.menuLogo {
  padding: 1em;
}

h6 {
  --color: var(--ion-text-color);
}

.loader {
  display: flex;
  width: 100%;
  height: 100%;
  background-position: center;
  justify-content: center;
  align-items: center;
  background-size: cover;
  position: fixed;
  top: 0%;
  left: 0%;
  background-color: rgb(255, 255, 255);
  opacity: 0.9;
}
.loader img {
  width: 200px;
  height: auto;
}

.opts-cont-menu {
  background-color: #00c1f9;
  width: 100%;
  height: 56px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0em 1em;
  /*.name-client{

  }*/
}
.opts-cont-menu .tog-menu-btn {
  background-color: transparent;
}
.opts-cont-menu .tog-menu-btn i {
  color: #fff;
  font-size: 1.7em;
}
.opts-cont-menu .tog-search-bar {
  background-color: transparent;
}
.opts-cont-menu .tog-search-bar i {
  color: #fff;
  font-size: 1.2em;
}
.opts-cont-menu .cart-go {
  font-size: 1em;
  color: #fff;
  text-decoration: none;
}
.opts-cont-menu .cart-go .i-l {
  font-size: 0.8em;
  background-color: #f00;
  padding: 0.2em;
  border-radius: 4px;
  margin-left: 0.3em;
}

.cel-menu {
  display: none;
}

.desk-header-app {
  display: block;
}

.desk-footer-app {
  display: block;
}

.gorgori {
  display: none;
}

.search_toggle {
  width: 100%;
  height: 100%;
}
.search_toggle #axbody {
  max-height: none !important;
  min-height: 100% !important;
  list-style: none;
  overflow-y: scroll !important;
  width: 100% !important;
  height: 20em;
  padding-inline-start: 0px;
  padding: 0em 1em;
  /*.ui-corner-all:last-child{
    border-bottom: none;
    margin-bottom: none;
  }*/
}
.search_toggle #axbody .ui-corner-all {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1em;
  border-bottom: 1px solid #00d7ff;
  border-bottom-style: dashed;
  padding-bottom: 0.75em;
  margin-bottom: 1em;
}
.search_toggle #axbody .search_lewa {
  display: block;
  width: 5em;
  height: 5em;
  border: 1px solid #00d3ff;
  border-radius: 50%;
  background-position: center;
  background-size: cover;
  overflow: hidden;
}
.search_toggle #axbody .search_lewa img {
  width: 100%;
  height: 100%;
}
.search_toggle #axbody .search_prawa {
  width: calc(100% - 6em);
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 0.36em;
}
.search_toggle #axbody .search_prawa .search_marka {
  color: #fff;
  font-weight: 100;
  font-size: 0.7em;
}
.search_toggle #axbody .search_prawa .search_nazwa {
  font-size: 0.85em;
  color: #fff;
  font-weight: 400;
}
.search_toggle #axbody .search_prawa .search_cena {
  font-size: 0.9em;
  color: #fff;
  font-weight: 100;
}
.search_toggle ul::-webkit-scrollbar {
  width: 0.35em;
  background-color: transparent;
  height: 0.7em;
}
.search_toggle ul::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.7176470588);
  width: 0.25em;
}
.search_toggle #search_plugin {
  width: 100%;
  height: 100%;
}
.search_toggle #search_plugin form {
  width: 100%;
  height: 100%;
}
.search_toggle #search_plugin form .buscainp {
  width: 100%;
  height: 100%;
  padding: 0em 1em;
  border-radius: 0em 3em 3em 0em;
  background-color: transparent;
  border: none;
  color: #fff;
  font-size: 0.9em;
}
.search_toggle #search_plugin form .buscainp:focus {
  outline: none;
}
.search_toggle #search_plugin form .buscainp::placeholder {
  color: rgba(255, 255, 255, 0.671);
  font-size: 0.8em;
}
.search_toggle .conten-abs {
  position: absolute;
  min-width: 40em;
  height: auto;
  top: 3em;
  right: 0;
  z-index: 10;
  background-color: #00a3c7;
  padding: 1em;
  border-radius: 2em;
}
.search_toggle .conten-abs .cuerpoPistas .txt-decir {
  margin: 0;
  margin-bottom: 0.5em;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4em;
  font-weight: 100;
  cursor: pointer;
}
.search_toggle .conten-abs .cuerpoPistas .ud1 {
  font-size: 0.6em;
  margin-left: 1em;
  color: #fff;
}
.search_toggle .conten-abs .cuerpoPistas .lasPistas {
  width: 100%;
  max-height: 8em;
  background-color: #0096b5;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5em;
  padding: 1em;
  overflow-y: scroll;
  border-radius: 2em 0em 0em 2em;
  transition: 0.2s all ease-in-out;
}
.search_toggle .conten-abs .cuerpoPistas .lasPistas::-webkit-scrollbar {
  width: 0.35em;
  background-color: transparent;
  height: 0.7em;
}
.search_toggle .conten-abs .cuerpoPistas .lasPistas::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.7176470588);
  width: 0.25em;
}
.search_toggle .conten-abs .cuerpoPistas .lasPistas div {
  width: -moz-fit-content;
  width: fit-content;
  display: inline-block;
  padding: 5px 10px;
  color: #00d9ff;
  border: 1px dashed #00d3ff;
  margin: 3px;
  border-radius: 3px;
  cursor: pointer;
  transition: 0.6s all ease-in-out;
}
.search_toggle .conten-abs .cuerpoPistas .lasPistas div:hover {
  color: #ffffff;
  border: 1px dashed #ffffff;
}
.search_toggle .conten-abs .dowi {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1em;
}
.search_toggle .conten-abs .dowi .lefti {
  width: 40%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0.3em;
}
.search_toggle .conten-abs .dowi .lefti .card {
  width: 100%;
  height: 3em;
  background-color: #0096b2;
  padding: 0.1em;
  border-radius: 0.5em;
  transition: 0.2s all ease-in-out;
  overflow: hidden;
}
.search_toggle .conten-abs .dowi .lefti .card .lista {
  overflow-y: scroll;
  width: 100%;
  height: 9em;
}
.search_toggle .conten-abs .dowi .lefti .card .lista::-webkit-scrollbar {
  width: 0.35em;
  background-color: transparent;
  height: 0.7em;
}
.search_toggle .conten-abs .dowi .lefti .card .lista::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.7176470588);
  width: 0.25em;
}
.search_toggle .conten-abs .dowi .lefti .card .lista div {
  position: relative;
  border-bottom: 1px solid #ffffff !important;
  width: 100%;
  height: 2.5em;
  display: flex !important;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  font-size: 0.9em;
  font-weight: 100;
}
.search_toggle .conten-abs .dowi .lefti .card .lista div input[type=checkbox] {
  cursor: pointer;
  width: 1.2em;
  height: 1.2em;
}
.search_toggle .conten-abs .dowi .lefti .card .taitl-filt {
  text-align: center;
  cursor: pointer;
  color: #fff;
  font-size: 0.9em;
  font-weight: 100;
}
.search_toggle .conten-abs .dowi .lefti .card .taitl-filt i {
  font-size: 0.7em;
  color: #fff;
}
.search_toggle .conten-abs .dowi .lefti .card .category-tree {
  overflow-y: unset !important;
  padding: 0em 0em;
  margin-block-start: 0em;
  margin-block-end: 0em;
  height: auto;
}
.search_toggle .conten-abs .dowi .lefti .card .category-tree .less {
  height: auto !important;
}
.search_toggle .conten-abs .dowi .lefti .card .category-tree .less div {
  border-bottom: none;
}
.search_toggle .conten-abs .dowi .lefti .card .category-tree .less .w-100 {
  overflow-y: unset !important;
}
.search_toggle .conten-abs .dowi .rigti {
  width: 60%;
  height: auto;
  height: 25em;
  background-color: #0096b3;
  border-radius: 2em;
}
.search_toggle .conten-abs .dowi .rigti .result-taitl {
  color: #fff;
  font-size: 1em;
  font-weight: 100;
}

@media (max-width: 992px) {
  .cel-menu {
    position: fixed;
    left: -100%;
    top: 0;
    width: 80%;
    height: 100%;
    background-color: #ffffff;
    z-index: 100;
    transition: 0.3s all ease-in-out;
    display: block;
  }
  .cel-menu .rest-close {
    width: 25%;
    height: 100%;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.3);
    top: 0;
    right: -25%;
  }
  .cel-menu .closemen {
    position: absolute;
    top: 0.5em;
    right: 0.5em;
    color: #fff;
    font-size: 1.8em;
  }
  .cel-menu .list-cont-opcs {
    width: 100%;
    height: calc(100% - 2.5em);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    overflow-y: scroll;
    padding-top: env(safe-area-inset-top);
  }
  .cel-menu .list-cont-opcs .porta-cel-cont {
    width: 100%;
    height: auto;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .cel-menu .list-cont-opcs .porta-cel-cont .log-cont {
    width: 100%;
    height: auto;
    padding: 1em;
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
  .cel-menu .list-cont-opcs .porta-cel-cont .log-cont .imag {
    width: 12em;
    height: auto;
  }
  .cel-menu .list-cont-opcs .blue-zone {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    background-color: rgb(57, 184, 235);
    padding: 1em 0em;
  }
  .cel-menu .list-cont-opcs .blue-zone .opt-blue-zone {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 3em;
    padding: 0.7em 0em;
    padding-left: 3em;
    text-decoration: none;
  }
  .cel-menu .list-cont-opcs .blue-zone .opt-blue-zone .icona-opt {
    color: #fff;
    font-size: 0.9em;
    width: 1.4em;
  }
  .cel-menu .list-cont-opcs .blue-zone .opt-blue-zone .txt-opt-bz {
    color: #fff;
    font-size: 0.8em;
  }
  .cel-menu .list-cont-opcs .rest-opts-cont {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    background-color: #fff;
    padding: 1em 0em;
  }
  .cel-menu .list-cont-opcs .rest-opts-cont .opt-rest-zone {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 3em;
    padding: 0.7em 0em;
    padding-left: 1.5em;
    text-decoration: none;
  }
  .cel-menu .list-cont-opcs .rest-opts-cont .opt-rest-zone .icona-opt {
    color: rgb(57, 184, 235);
    font-size: 1.3em;
    width: 1.2em;
  }
  .cel-menu .list-cont-opcs .rest-opts-cont .opt-rest-zone .txt-opt-r {
    color: rgb(57, 184, 235);
    font-size: 0.8em;
  }
  .cel-menu .list-cont-opcs::-webkit-scrollbar {
    width: 0.1em;
    background-color: transparent;
    height: 0.7em;
  }
  .cel-menu .list-cont-opcs::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 1vh;
    width: 0.25em;
  }
  .desk-header-app {
    display: none;
  }
  .desk-footer-app {
    display: none;
  }
  .gorgori {
    display: block;
  }
  .desk-header {
    display: none;
  }
  .footer-desk {
    display: none;
  }
  .search_toggle {
    /*position: absolute;
    top: calc(3.5em);*/
  }
  .search_toggle .conten-abs {
    min-width: 0em;
    width: 100%;
    top: 2.2em;
    border-radius: 0em;
    height: calc(100vh - 5.7em);
    overflow-y: scroll;
    background-color: #00c1f9;
  }
  .search_toggle .conten-abs .dowi {
    flex-direction: column;
  }
  .search_toggle .conten-abs .dowi .lefti {
    width: 100%;
  }
  .search_toggle .conten-abs .dowi .rigti {
    width: 100%;
    height: 20em;
    overflow: hidden;
  }
  .search_toggle #search_plugin form .buscainp {
    background-color: #17c2fc;
    border-radius: 0em 0em 0em 0em;
    height: 2.5em;
  }
}
@media (min-width: 992px) {
  .asideMenu {
    display: none !important;
    position: relative !important;
    z-index: -1 !important;
    visibility: hidden !important;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/swiper/swiper.scss","webpack://./src/app/app.component.scss","webpack://./node_modules/swiper/modules/navigation/navigation.scss","webpack://./node_modules/swiper/modules/pagination/pagination.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;EAAA;AAcE;EACE,2BAAA;EACA,4sEAAA;EAEA,gBAAA;EACA,kBAAA;ACHJ;ADOE;EACE,6BAAA;ACLJ;;ADQA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,6BAAA;EACA,UAAA;ACLF;;ADOA;EACE,sBAAA;ACJF;;ADMA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;ACHF;;ADKA;;EAEE,iCAAA;ACFF;;ADIA;EACE,mBAAA;ACDF;ADEE;EACE,mBAAA;ACAJ;;ADGA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;ACAF;;ADEA;EACE,kBAAA;ACCF;;ADCA,gBAAA;AAEE;;EAEE,YAAA;ACCJ;ADEE;EACE,uBAAA;EACA,sCAAA;ACAJ;;ADGA;EACE,wBAAA;EACA,2BAAA;ACAF;;ADEA,eAAA;AAEE;EAEE,mBAAA;ACDJ;ADGE;;;;;;;;EAQE,4BAAA;ACDJ;ADGE;;;;;EAKE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;ACDJ;ADGE;EACE,+BAAA;ACDJ;ADGE;EACE,gFAAA;ACDJ;ADGE;EACE,iFAAA;ACDJ;ADGE;EACE,+EAAA;ACDJ;ADGE;EACE,kFAAA;ACDJ;;ADKA,aAAA;AAEE;EACE,cAAA;EACA,qBAAA,EAAA,gBAAA;EACA,wBAAA,EAAA,mCAAA;ACHJ;ADII;EACE,aAAA;ACFN;ADKE;EACE,8BAAA;ACHJ;;ADOE;EACE,6BAAA;ACJJ;;ADQE;EACE,6BAAA;ACLJ;;ADSE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ACNJ;ADSI;EACE,yDAAA;ACPN;ADSI;EACE,YAAA;EACA,0CAAA;ACPN;ADWI;EACE,wDAAA;ACTN;ADWI;EACE,WAAA;EACA,2CAAA;ACTN;ADaE;EACE,gCAAA;EACA,wBAAA;ACXJ;;ACzKE;EACE,8BAAA;EACA;;GAAA;AD8KJ;;ACzKA;;EAEE,kBAAA;EACA,QAAA;EACA,oDAAA;EACA,qCAAA;EACA,yDAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gEAAA;AD4KF;AC3KE;;EACE,aAAA;EACA,YAAA;EACA,oBAAA;AD8KJ;AC5KE;;EACE,UAAA;EACA,YAAA;EACA,oBAAA;AD+KJ;AC7KE;;EACE,wBAAA;ADgLJ;AC9KE;;EACE,yBAAA;EACA,wCAAA;EACA,+BAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;ADiLJ;;AC9KA;;EAKE,UAAA;EACA,WAAA;AD8KF;AClLE;;EACE,eAAA;ADqLJ;;AChLA;;EAKE,WAAA;EACA,UAAA;ADgLF;ACpLE;;EACE,eAAA;ADuLJ;;ACjLA;EACE,aAAA;ADoLF;;AEhPE;EACE;;;;;;;;;;GAAA;AF6PJ;;AEhPA;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,+BAAA;EACA,WAAA;AFmPF;AElPE;EACE,UAAA;AFoPJ;AElPE;EAEE,wBAAA;AFmPJ;;AEhPA,kBAAA;AACA;;;;EAIE,YAAA;EACA,OAAA;EACA,WAAA;AFmPF;;AEjPA,YAAA;AACA;EACE,gBAAA;EACA,YAAA;AFoPF;AEnPE;EACE,sBAAA;EACA,kBAAA;AFqPJ;AEnPE;EACE,mBAAA;AFqPJ;AEnPE;EACE,mBAAA;AFqPJ;AEnPE;EACE,sBAAA;AFqPJ;AEnPE;EACE,sBAAA;AFqPJ;AEnPE;EACE,sBAAA;AFqPJ;AEnPE;EACE,sBAAA;AFqPJ;;AElPA;EACE,uFAAA;EACA,yFAAA;EACA,qBAAA;EACA,kBAAA;EACA,gEAAA;EACA,8DAAA;AFqPF;AEpPW;EACP,YAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;AFsPJ;;AEpPE;EACE,eAAA;AFuPJ;AEpPE;EACE,wBAAA;AFsPJ;;AEnPA;EACE,mDAAA;EACA,qEAAA;AFsPF;;AEnPA;;EAEE,WAAA;EACA,QAAA;EACA,oCAAA;AFsPF;AErPE;;EACE,2DAAA;EACA,cAAA;AFwPJ;AEtPE;;EACE,QAAA;EACA,2BAAA;EACA,UAAA;AFyPJ;AExPI;;EACE,qBAAA;EACA,sCAAA;AF2PN;;AErPE;;EACE,6DAAA;AFyPJ;AEvPE;;EACE,SAAA;EACA,2BAAA;EACA,mBAAA;AF0PJ;AEzPI;;EACE,uCAAA;AF4PN;;AExPA;EACE,wCAAA;AF2PF;;AEzPA,aAAA;AACA;EACE,+BAAA;EACA,kBAAA;AF4PF;AE3PE;EACE,qEAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;AF6PJ;AE3PE;EACE,2BAAA;AF6PJ;AE3PE;EAIE,WAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;AF0PJ;AExPE;EAIE,UAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;AFuPJ;;AEpPA;EACE,aAAA;AFuPF;;AAzZA;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;AA4ZF;;AAzZA;EACE,gBAAA;EACA,eAAA;EACA,UAAA;AA4ZF;;AAzZA;EACE,qBAAA;EACA,UAAA;EACA,iBAAA;AA4ZF;;AAzZA;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AA4ZF;;AAzZA;EACE,cAAA;AA4ZF;;AAzZA;EACE,2EAAA;AA4ZF;;AAzZA;EACE,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AA4ZF;;AAzZA;EACE,eAAA;AA4ZF;;AAzZA;EACE,mBAAA;AA4ZF;;AAzZA;;EAEE,kBAAA;AA4ZF;;AAzZA;EACE,2DAAA;AA4ZF;;AAzZA;EACE,eAAA;EACA,gBAAA;EAEA,gBAAA;AA2ZF;;AAxZA;EACE,eAAA;EAEA,mBAAA;EAEA,cAAA;EAEA,gBAAA;AAwZF;;AArZA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;AAwZF;;AArZA;EACE,sDAAA;AAwZF;;AArZA;EACE,+BAAA;AAwZF;;AArZA;EACE,cAAA;AAwZF;;AArZA;EACE,gBAAA;AAwZF;;AArZA;EACE,sBAAA;AAwZF;;AArZA;EACE,mBAAA;AAwZF;;AArZA;EACE,iBAAA;EACA,mBAAA;AAwZF;;AArZA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;AAwZF;;AArZA;EACE,+BAAA;AAwZF;;AArZA;EACE,eAAA;EACA,cAAA;AAwZF;;AArZA;EACE,kBAAA;AAwZF;;AArZA;;EAEE,kBAAA;EACA,mBAAA;AAwZF;;AArZA;EACE,kBAAA;AAwZF;;AArZA;EACE,iCAAA;AAwZF;;AArZA;EACE,YAAA;AAwZF;;AArZA;EACE,8BAAA;AAwZF;;AArZA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,oCAAA;EACA,YAAA;AAwZF;AAtZE;EACE,YAAA;EACA,YAAA;AAwZJ;;AAlZA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EAWA;;IAAA;AA6YF;AAtZE;EACE,6BAAA;AAwZJ;AAtZI;EACE,WAAA;EACA,gBAAA;AAwZN;AAhZE;EACE,6BAAA;AAkZJ;AAhZI;EACE,WAAA;EACA,gBAAA;AAkZN;AA9YE;EACE,cAAA;EACA,WAAA;EACA,qBAAA;AAgZJ;AA9YI;EACE,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AAgZN;;AA3YA;EACE,aAAA;AA8YF;;AA3YA;EACE,cAAA;AA8YF;;AA3YA;EACE,cAAA;AA8YF;;AA3YA;EACE,aAAA;AA8YF;;AA3YA;EACE,WAAA;EACA,YAAA;AA8YF;AA5YE;EACE,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA,6BAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EAeA;;;IAAA;AAmYJ;AAhZI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;EACA,gCAAA;EACA,2BAAA;EACA,sBAAA;EACA,kBAAA;AAkZN;AA1YI;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,2BAAA;EACA,sBAAA;EACA,gBAAA;AA4YN;AA1YM;EACE,WAAA;EACA,YAAA;AA4YR;AAxYI;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,WAAA;AA0YN;AAxYM;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AA0YR;AAvYM;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;AAyYR;AAtYM;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;AAwYR;AAnYE;EACE,aAAA;EACA,6BAAA;EACA,aAAA;AAqYJ;AAlYE;EACE,mDAAA;EAEA,aAAA;AAmYJ;AAhYE;EACE,WAAA;EACA,YAAA;AAkYJ;AAhYI;EACE,WAAA;EACA,YAAA;AAkYN;AAhYM;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AAkYR;AA/XM;EACE,aAAA;AAiYR;AA9XM;EACE,iCAAA;EACA,gBAAA;AAgYR;AA3XE;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;AA6XJ;AAzXM;EACE,SAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AA2XR;AAxXM;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;AA0XR;AAvXM;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,gCAAA;AAyXR;AAtXM;EACE,aAAA;EACA,6BAAA;EACA,aAAA;AAwXR;AArXM;EACE,mDAAA;EAEA,aAAA;AAsXR;AAnXM;EACE,uBAAA;EAAA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;AAqXR;AAlXM;EACE,cAAA;EACA,0BAAA;AAoXR;AAhXI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,QAAA;AAkXN;AAhXM;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,UAAA;AAkXR;AAhXQ;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;EACA,oBAAA;EACA,gCAAA;EACA,gBAAA;AAkXV;AAhXU;EACE,kBAAA;EACA,WAAA;EACA,WAAA;AAkXZ;AA/WU;EACE,aAAA;EACA,6BAAA;EACA,aAAA;AAiXZ;AA9WU;EACE,mDAAA;EAEA,aAAA;AA+WZ;AA5WU;EACE,kBAAA;EACA,2CAAA;EACA,WAAA;EACA,aAAA;EACA,wBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AA8WZ;AA5WY;EACE,eAAA;EACA,YAAA;EACA,aAAA;AA8Wd;AA1WU;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AA4WZ;AA1WY;EACE,gBAAA;EACA,WAAA;AA4Wd;AAxWU;EACE,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;AA0WZ;AAxWY;EACE,uBAAA;AA0Wd;AAxWc;EACE,mBAAA;AA0WhB;AAvWc;EACE,4BAAA;AAyWhB;AAlWM;EACE,UAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAoWR;AAlWQ;EACE,WAAA;EACA,cAAA;EACA,gBAAA;AAoWV;;AA7VA;EACE;IACE,eAAA;IACA,WAAA;IACA,MAAA;IACA,UAAA;IACA,YAAA;IACA,yBAAA;IACA,YAAA;IACA,gCAAA;IAEA,cAAA;EA+VF;EA7VE;IACE,UAAA;IACA,YAAA;IACA,kBAAA;IACA,oCAAA;IACA,MAAA;IACA,WAAA;EA+VJ;EA5VE;IACE,kBAAA;IACA,UAAA;IACA,YAAA;IACA,WAAA;IACA,gBAAA;EA8VJ;EA3VE;IAEE,WAAA;IACA,0BAAA;IACA,aAAA;IACA,sBAAA;IACA,2BAAA;IACA,uBAAA;IACA,kBAAA;IACA,qCAAA;EA4VJ;EA1VI;IACE,WAAA;IACA,YAAA;IACA,sBAAA;IACA,aAAA;IACA,sBAAA;IACA,2BAAA;IACA,uBAAA;EA4VN;EA1VM;IACE,WAAA;IACA,YAAA;IACA,YAAA;IACA,aAAA;IACA,uBAAA;IACA,uBAAA;EA4VR;EA1VQ;IACE,WAAA;IACA,YAAA;EA4VV;EAvVI;IACE,WAAA;IACA,YAAA;IACA,aAAA;IACA,sBAAA;IACA,2BAAA;IACA,uBAAA;IACA,mCAAA;IACA,gBAAA;EAyVN;EAvVM;IACE,WAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;IACA,2BAAA;IACA,mBAAA;IACA,QAAA;IACA,kBAAA;IACA,iBAAA;IACA,qBAAA;EAyVR;EAvVQ;IACE,WAAA;IACA,gBAAA;IACA,YAAA;EAyVV;EAtVQ;IACE,WAAA;IACA,gBAAA;EAwVV;EAnVI;IACE,WAAA;IACA,YAAA;IACA,aAAA;IACA,sBAAA;IACA,2BAAA;IACA,uBAAA;IACA,sBAAA;IACA,gBAAA;EAqVN;EAnVM;IACE,WAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;IACA,2BAAA;IACA,mBAAA;IACA,QAAA;IACA,kBAAA;IACA,mBAAA;IACA,qBAAA;EAqVR;EAnVQ;IACE,wBAAA;IACA,gBAAA;IACA,YAAA;EAqVV;EAlVQ;IACE,wBAAA;IACA,gBAAA;EAoVV;EA9UE;IACE,YAAA;IACA,6BAAA;IACA,aAAA;EAgVJ;EA7UE;IACE,6BAAA;IACA,kBAAA;IACA,aAAA;EA+UJ;EA3UA;IACE,aAAA;EA6UF;EA1UA;IACE,aAAA;EA4UF;EAzUA;IACE,cAAA;EA2UF;EAxUA;IACE,aAAA;EA0UF;EAvUA;IACE,aAAA;EAyUF;EAtUA;IACE;sBAAA;EAyUF;EAtUE;IACE,cAAA;IACA,WAAA;IACA,UAAA;IACA,kBAAA;IACA,2BAAA;IACA,kBAAA;IACA,yBAAA;EAwUJ;EAtUI;IACE,sBAAA;EAwUN;EAtUM;IACE,WAAA;EAwUR;EArUM;IACE,WAAA;IACA,YAAA;IACA,gBAAA;EAuUR;EAhUM;IACE,yBAAA;IACA,8BAAA;IACA,aAAA;EAkUR;AACF;AA5TA;EACE;IACE,wBAAA;IACA,6BAAA;IACA,sBAAA;IACA,6BAAA;EA8TF;AACF","sourcesContent":["/**\n * Swiper 8.4.7\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * https://swiperjs.com\n *\n * Copyright 2014-2023 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: January 30, 2023\n */\n\n@import 'swiper-vars.scss';\n@at-root {\n  @font-face {\n    font-family: 'swiper-icons';\n    src: url('data:application/font-woff;charset=utf-8;base64, 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')\n      format('woff');\n    font-weight: 400;\n    font-style: normal;\n  }\n}\n@at-root {\n  :root {\n    --swiper-theme-color: #{$themeColor};\n  }\n}\n.swiper {\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  /* Fix of Webkit flickering */\n  z-index: 1;\n}\n.swiper-vertical > .swiper-wrapper {\n  flex-direction: column;\n}\n.swiper-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform;\n  box-sizing: content-box;\n}\n.swiper-android .swiper-slide,\n.swiper-wrapper {\n  transform: translate3d(0px, 0, 0);\n}\n.swiper-pointer-events {\n  touch-action: pan-y;\n  &.swiper-vertical {\n    touch-action: pan-x;\n  }\n}\n.swiper-slide {\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transition-property: transform;\n}\n.swiper-slide-invisible-blank {\n  visibility: hidden;\n}\n/* Auto Height */\n.swiper-autoheight {\n  &,\n  .swiper-slide {\n    height: auto;\n  }\n\n  .swiper-wrapper {\n    align-items: flex-start;\n    transition-property: transform, height;\n  }\n}\n.swiper-backface-hidden .swiper-slide {\n  transform: translateZ(0);\n  backface-visibility: hidden;\n}\n/* 3D Effects */\n.swiper-3d {\n  &,\n  &.swiper-css-mode .swiper-wrapper {\n    perspective: 1200px;\n  }\n  .swiper-wrapper,\n  .swiper-slide,\n  .swiper-slide-shadow,\n  .swiper-slide-shadow-left,\n  .swiper-slide-shadow-right,\n  .swiper-slide-shadow-top,\n  .swiper-slide-shadow-bottom,\n  .swiper-cube-shadow {\n    transform-style: preserve-3d;\n  }\n  .swiper-slide-shadow,\n  .swiper-slide-shadow-left,\n  .swiper-slide-shadow-right,\n  .swiper-slide-shadow-top,\n  .swiper-slide-shadow-bottom {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    z-index: 10;\n  }\n  .swiper-slide-shadow {\n    background: rgba(0, 0, 0, 0.15);\n  }\n  .swiper-slide-shadow-left {\n    background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  .swiper-slide-shadow-right {\n    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  .swiper-slide-shadow-top {\n    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n  .swiper-slide-shadow-bottom {\n    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n  }\n}\n\n/* CSS Mode */\n.swiper-css-mode {\n  > .swiper-wrapper {\n    overflow: auto;\n    scrollbar-width: none; /* For Firefox */\n    -ms-overflow-style: none; /* For Internet Explorer and Edge */\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n  > .swiper-wrapper > .swiper-slide {\n    scroll-snap-align: start start;\n  }\n}\n.swiper-horizontal.swiper-css-mode {\n  > .swiper-wrapper {\n    scroll-snap-type: x mandatory;\n  }\n}\n.swiper-vertical.swiper-css-mode {\n  > .swiper-wrapper {\n    scroll-snap-type: y mandatory;\n  }\n}\n.swiper-centered {\n  > .swiper-wrapper::before {\n    content: '';\n    flex-shrink: 0;\n    order: 9999;\n  }\n  &.swiper-horizontal {\n    > .swiper-wrapper > .swiper-slide:first-child {\n      margin-inline-start: var(--swiper-centered-offset-before);\n    }\n    > .swiper-wrapper::before {\n      height: 100%;\n      width: var(--swiper-centered-offset-after);\n    }\n  }\n  &.swiper-vertical {\n    > .swiper-wrapper > .swiper-slide:first-child {\n      margin-block-start: var(--swiper-centered-offset-before);\n    }\n    > .swiper-wrapper::before {\n      width: 100%;\n      height: var(--swiper-centered-offset-after);\n    }\n  }\n\n  > .swiper-wrapper > .swiper-slide {\n    scroll-snap-align: center center;\n    scroll-snap-stop: always;\n  }\n}\n\n\n\n","@import 'swiper/scss';\r\n@import 'swiper/scss/navigation';\r\n@import 'swiper/scss/pagination';\r\n\r\n.line-filter {\r\n  text-align: center;\r\n  line-height: 20px;\r\n  background: #70c2d1;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.name-client{\r\n  font-size: 0.9em;\r\n  max-width: 12em;\r\n  padding: 0;\r\n}\r\n\r\nion-searchbar {\r\n  --icon-color: #1ca3c9;\r\n  width: 95%;\r\n  margin-left: 10px;\r\n}\r\n\r\n.search-container {\r\n  width: 90vw;\r\n  right: 5vw;\r\n  height: auto;\r\n  max-height: 50vh;\r\n  overflow-y: scroll;\r\n  position: absolute;\r\n}\r\n\r\nmenu-text{\r\n  font-size: 2em;\r\n}\r\n\r\nion-menu ion-content {\r\n  --background: var(--ion-item-background, var(--ion-background-color, #fff));\r\n}\r\n\r\nion-menu.md ion-content {\r\n  --padding-start: 8px;\r\n  --padding-end: 8px;\r\n  --padding-top: 20px;\r\n  --padding-bottom: 20px;\r\n}\r\n\r\nion-menu.md ion-list {\r\n  padding: 20px 0;\r\n}\r\n\r\nion-menu.md ion-note {\r\n  margin-bottom: 30px;\r\n}\r\n\r\nion-menu.md ion-list-header,\r\nion-menu.md ion-note {\r\n  padding-left: 10px;\r\n}\r\n\r\nion-menu.md ion-list#inbox-list {\r\n  border-bottom: 1px solid var(--ion-color-step-150, #d7d8da);\r\n}\r\n\r\nion-menu.md ion-list#inbox-list ion-list-header {\r\n  font-size: 22px;\r\n  font-weight: 600;\r\n\r\n  min-height: 20px;\r\n}\r\n\r\nion-menu.md ion-list#labels-list ion-list-header {\r\n  font-size: 16px;\r\n\r\n  margin-bottom: 18px;\r\n\r\n  color: #757575;\r\n\r\n  min-height: 26px;\r\n}\r\n\r\nion-menu.md ion-item {\r\n  --padding-start: 10px;\r\n  --padding-end: 10px;\r\n  border-radius: 4px;\r\n}\r\n\r\nion-menu.md ion-item.selected {\r\n  --background: rgba(var(--ion-color-primary-rgb), 0.14);\r\n}\r\n\r\nion-menu.md ion-item.selected ion-icon {\r\n  color: var(--ion-color-primary);\r\n}\r\n\r\nion-menu.md ion-item ion-icon h6 {\r\n  color: #616e7e;\r\n}\r\n\r\nion-menu.md ion-item ion-label {\r\n  font-weight: 500;\r\n}\r\n\r\nion-menu.ios ion-content {\r\n  --padding-bottom: 20px;\r\n}\r\n\r\nion-menu.ios ion-list {\r\n  padding: 20px 0 0 0;\r\n}\r\n\r\nion-menu.ios ion-note {\r\n  line-height: 24px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\nion-menu.ios ion-item {\r\n  --padding-start: 16px;\r\n  --padding-end: 16px;\r\n  --min-height: 50px;\r\n}\r\n\r\nion-menu.ios ion-item.selected ion-icon {\r\n  color: var(--ion-color-primary);\r\n}\r\n\r\nion-menu.ios ion-item ion-icon {\r\n  font-size: 24px;\r\n  color: #73849a;\r\n}\r\n\r\nion-menu.ios ion-list#labels-list ion-list-header {\r\n  margin-bottom: 8px;\r\n}\r\n\r\nion-menu.ios ion-list-header,\r\nion-menu.ios ion-note {\r\n  padding-left: 16px;\r\n  padding-right: 16px;\r\n}\r\n\r\nion-menu.ios ion-note {\r\n  margin-bottom: 8px;\r\n}\r\n\r\nion-item.selected {\r\n  --color: var(--ion-color-primary);\r\n}\r\n\r\n.menuLogo {\r\n  padding: 1em;\r\n}\r\n\r\nh6 {\r\n  --color: var(--ion-text-color);\r\n}\r\n\r\n.loader {\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-position: center;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-size: cover;\r\n  position: fixed;\r\n  top: calc(0%);\r\n  left: calc(0%);\r\n  background-color: rgb(255, 255, 255);\r\n  opacity: 0.9;\r\n\r\n  img{\r\n    width: 200px;\r\n    height: auto;\r\n\r\n  }\r\n\r\n}\r\n\r\n.opts-cont-menu{\r\n  background-color: #00c1f9;\r\n  width: 100%;\r\n  height: 56px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0em 1em;\r\n\r\n  .tog-menu-btn{\r\n    background-color: transparent;\r\n\r\n    i{\r\n      color: #fff;\r\n      font-size: 1.7em;\r\n    }\r\n  }\r\n\r\n  /*.name-client{\r\n\r\n  }*/\r\n\r\n  .tog-search-bar{\r\n    background-color: transparent;\r\n\r\n    i{\r\n      color: #fff;\r\n      font-size: 1.2em;\r\n    }\r\n  }\r\n\r\n  .cart-go{\r\n    font-size: 1em;\r\n    color: #fff;\r\n    text-decoration: none;\r\n\r\n    .i-l{\r\n      font-size: .8em;\r\n      background-color: #f00;\r\n      padding: 0.2em;\r\n      border-radius: 4px;\r\n      margin-left: 0.3em;\r\n    }\r\n  }\r\n}\r\n\r\n.cel-menu{\r\n  display: none;\r\n}\r\n\r\n.desk-header-app{\r\n  display: block;\r\n}\r\n\r\n.desk-footer-app{\r\n  display: block;\r\n}\r\n\r\n.gorgori{ // ion-header\r\n  display: none;\r\n}\r\n\r\n.search_toggle{\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  #axbody{\r\n    max-height: none!important;\r\n    min-height: 100% !important;\r\n    list-style: none;\r\n    overflow-y: scroll!important;\r\n    width: 100%!important;\r\n    height: 20em;\r\n    padding-inline-start: 0px;\r\n    padding: 0em 1em;\r\n\r\n    .ui-corner-all{\r\n      width: 100%;\r\n      height: auto;\r\n      display: flex;\r\n      justify-content: flex-start;\r\n      align-items: center;\r\n      gap: 1em;\r\n      border-bottom: 1px solid #00d7ff;\r\n      border-bottom-style: dashed;\r\n      padding-bottom: 0.75em;\r\n      margin-bottom: 1em;\r\n    }\r\n\r\n    /*.ui-corner-all:last-child{\r\n      border-bottom: none;\r\n      margin-bottom: none;\r\n    }*/\r\n\r\n    .search_lewa{\r\n      display: block;\r\n      width: 5em;\r\n      height: 5em;\r\n      border: 1px solid #00d3ff;\r\n      border-radius: 50%;\r\n      background-position: center;\r\n      background-size: cover;\r\n      overflow: hidden;\r\n\r\n      img{\r\n        width: 100%;\r\n        height: 100%;\r\n      }\r\n    }\r\n\r\n    .search_prawa{\r\n      width: calc(100% - 6em);\r\n      height: auto;\r\n      display: flex;\r\n      flex-direction: column;\r\n      justify-content: center;\r\n      align-items: flex-start;\r\n      gap: 0.36em;\r\n\r\n      .search_marka{\r\n        color: #fff;\r\n        font-weight: 100;\r\n        font-size: .7em;\r\n      }\r\n\r\n      .search_nazwa{\r\n        font-size: .85em;\r\n        color: #fff;\r\n        font-weight: 400;\r\n      }\r\n\r\n      .search_cena{\r\n        font-size: .9em;\r\n        color: #fff;\r\n        font-weight: 100;\r\n      }\r\n    }\r\n  }\r\n\r\n  ul::-webkit-scrollbar {\r\n    width: .35em;\r\n    background-color: transparent;\r\n    height: .7em;\r\n  }\r\n    \r\n  ul::-webkit-scrollbar-thumb {\r\n    background-color: #ffffffb7;\r\n    //border-radius: 1vh;\r\n    width: 0.25em;\r\n  }\r\n\r\n  #search_plugin{\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    form{\r\n      width: 100%;\r\n      height: 100%;\r\n\r\n      .buscainp{\r\n        width: 100%;\r\n        height: 100%;\r\n        padding: 0em 1em;\r\n        border-radius: 0em 3em 3em 0em;\r\n        background-color: transparent;\r\n        border: none;\r\n        color: #fff;\r\n        font-size: .9em;\r\n      }\r\n\r\n      .buscainp:focus{\r\n        outline: none;\r\n      }\r\n\r\n      .buscainp::placeholder{\r\n        color: rgba(255, 255, 255, 0.671);\r\n        font-size: .8em;\r\n      }\r\n    }\r\n  }\r\n\r\n  .conten-abs{\r\n    position: absolute;\r\n    min-width: 40em;\r\n    height: auto;\r\n    top: 3em;\r\n    right: 0;\r\n    z-index: 10;\r\n    background-color: #00a3c7;\r\n    padding: 1em;\r\n    border-radius: 2em;\r\n\r\n    .cuerpoPistas{\r\n\r\n      .txt-decir{\r\n        margin: 0;\r\n        margin-bottom: 0.5em;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        font-size: 1.4em;\r\n        font-weight: 100;\r\n        cursor: pointer;\r\n      }\r\n\r\n      .ud1{\r\n        font-size: .6em;\r\n        margin-left: 1em;\r\n        color: #fff;\r\n      }\r\n\r\n      .lasPistas{\r\n        width: 100%;\r\n        max-height: 8em;\r\n        background-color: #0096b5;\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        justify-content: center;\r\n        gap: .5em;\r\n        padding: 1em;\r\n        overflow-y: scroll;\r\n        border-radius: 2em 0em 0em 2em;\r\n        transition: .2s all ease-in-out;\r\n      }\r\n\r\n      .lasPistas::-webkit-scrollbar {\r\n        width: .35em;\r\n        background-color: transparent;\r\n        height: .7em;\r\n      }\r\n        \r\n      .lasPistas::-webkit-scrollbar-thumb {\r\n        background-color: #ffffffb7;\r\n        //border-radius: 1vh;\r\n        width: 0.25em;\r\n      }\r\n\r\n      .lasPistas div{\r\n        width: fit-content;\r\n        display: inline-block;\r\n        padding: 5px 10px;\r\n        color: #00d9ff;\r\n        border: 1px dashed #00d3ff;\r\n        margin: 3px;\r\n        border-radius: 3px;\r\n        cursor: pointer;\r\n        transition: .6s all ease-in-out;\r\n      }\r\n\r\n      .lasPistas div:hover{\r\n        color: #ffffff;\r\n        border: 1px dashed #ffffff;\r\n      }\r\n    }\r\n\r\n    .dowi{\r\n      width: 100%;\r\n      height: auto;\r\n      display: flex;\r\n      flex-direction: row;\r\n      justify-content: flex-start;\r\n      align-items: flex-start;\r\n      gap: 1em;\r\n\r\n      .lefti{\r\n        width: 40%;\r\n        height: auto;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: flex-start;\r\n        align-items: flex-start;\r\n        gap: 0.3em;\r\n\r\n        .card{\r\n          width: 100%;\r\n          height: 3em;\r\n          background-color: #0096b2;\r\n          padding: 0.1em;\r\n          border-radius: 0.5em;\r\n          transition: .2s all ease-in-out;\r\n          overflow: hidden;\r\n\r\n          .lista{\r\n            overflow-y: scroll;\r\n            width: 100%;\r\n            height: 9em;\r\n          }\r\n\r\n          .lista::-webkit-scrollbar {\r\n            width: .35em;\r\n            background-color: transparent;\r\n            height: .7em;\r\n          }\r\n            \r\n          .lista::-webkit-scrollbar-thumb {\r\n            background-color: #ffffffb7;\r\n            //border-radius: 1vh;\r\n            width: 0.25em;\r\n          }\r\n\r\n          .lista div{\r\n            position: relative;\r\n            border-bottom: 1px solid #ffffff!important;\r\n            width: 100%;\r\n            height: 2.5em;\r\n            display: flex!important;\r\n            flex-direction: row;\r\n            justify-content: space-between;\r\n            align-items: center;\r\n            color: #fff;\r\n            font-size: .9em;\r\n            font-weight: 100;\r\n\r\n            input[type='checkbox']{\r\n              cursor: pointer;\r\n              width: 1.2em;\r\n              height: 1.2em;\r\n            }\r\n          }\r\n\r\n          .taitl-filt{\r\n            text-align: center;\r\n            cursor: pointer;\r\n            color: #fff;\r\n            font-size: .9em;\r\n            font-weight: 100;\r\n\r\n            i{\r\n              font-size: .7em;\r\n              color: #fff;\r\n            }\r\n          }\r\n\r\n          .category-tree{\r\n            overflow-y: unset!important;\r\n            padding: 0em 0em;\r\n            margin-block-start: 0em;\r\n            margin-block-end: 0em;\r\n            height: auto;\r\n\r\n            .less{\r\n              height: auto!important;\r\n\r\n              div{\r\n                border-bottom: none;\r\n              }\r\n\r\n              .w-100{\r\n                overflow-y: unset!important;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .rigti{\r\n        width: 60%;\r\n        height: auto;\r\n        height: 25em;\r\n        background-color: #0096b3;\r\n        border-radius: 2em;\r\n\r\n        .result-taitl{\r\n          color: #fff;\r\n          font-size: 1em;\r\n          font-weight: 100;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media(max-width: 992px){\r\n  .cel-menu{\r\n    position: fixed;\r\n    left: -100%;\r\n    top: 0;\r\n    width: 80%;\r\n    height: 100%;\r\n    background-color: #ffffff;\r\n    z-index: 100;\r\n    transition: .3s all ease-in-out;\r\n    //padding: 2em 2em;\r\n    display: block;\r\n\r\n    .rest-close{\r\n      width: 25%;\r\n      height: 100%;\r\n      position: absolute;\r\n      background-color: rgb(0 0 0 / 30%);\r\n      top: 0;\r\n      right: -25%;\r\n    }\r\n\r\n    .closemen{\r\n      position: absolute;\r\n      top: 0.5em;\r\n      right: 0.5em;\r\n      color: #fff;\r\n      font-size: 1.8em;\r\n    }\r\n\r\n    .list-cont-opcs{\r\n      //border: 1px solid red;\r\n      width: 100%;\r\n      height: calc(100% - 2.5em);\r\n      display: flex;\r\n      flex-direction: column;\r\n      justify-content: flex-start;\r\n      align-items: flex-start;\r\n      overflow-y: scroll;\r\n      padding-top: env(safe-area-inset-top);\r\n\r\n      .porta-cel-cont{\r\n        width: 100%;\r\n        height: auto;\r\n        background-color: #fff;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: flex-start;\r\n        align-items: flex-start;\r\n\r\n        .log-cont{\r\n          width: 100%;\r\n          height: auto;\r\n          padding: 1em;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: flex-start;\r\n\r\n          .imag{\r\n            width: 12em;\r\n            height: auto;\r\n          }\r\n        }\r\n      }  \r\n\r\n      .blue-zone{\r\n        width: 100%;\r\n        height: auto;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: flex-start;\r\n        align-items: flex-start;\r\n        background-color: rgb(57, 184, 235);\r\n        padding: 1em 0em;\r\n\r\n        .opt-blue-zone{\r\n          width: 100%;\r\n          height: auto;\r\n          display: flex;\r\n          flex-direction: row;\r\n          justify-content: flex-start;\r\n          align-items: center;\r\n          gap: 3em;\r\n          padding: 0.7em 0em;\r\n          padding-left: 3em;\r\n          text-decoration: none;\r\n\r\n          .icona-opt{\r\n            color: #fff;\r\n            font-size: .9em;\r\n            width: 1.4em;\r\n          }\r\n\r\n          .txt-opt-bz{\r\n            color: #fff;\r\n            font-size: .8em;\r\n          }\r\n        }\r\n      }\r\n\r\n      .rest-opts-cont{\r\n        width: 100%;\r\n        height: auto;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: flex-start;\r\n        align-items: flex-start;\r\n        background-color: #fff;\r\n        padding: 1em 0em;\r\n\r\n        .opt-rest-zone{\r\n          width: 100%;\r\n          height: auto;\r\n          display: flex;\r\n          flex-direction: row;\r\n          justify-content: flex-start;\r\n          align-items: center;\r\n          gap: 3em;\r\n          padding: 0.7em 0em;\r\n          padding-left: 1.5em;\r\n          text-decoration: none;\r\n\r\n          .icona-opt{\r\n            color: rgb(57, 184, 235);\r\n            font-size: 1.3em;\r\n            width: 1.2em;        \r\n          }\r\n\r\n          .txt-opt-r{\r\n            color: rgb(57, 184, 235);\r\n            font-size: .8em;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .list-cont-opcs::-webkit-scrollbar {\r\n      width: .1em;\r\n      background-color: transparent;\r\n      height: .7em;\r\n    }\r\n   \r\n    .list-cont-opcs::-webkit-scrollbar-thumb {\r\n      background-color: transparent;\r\n      border-radius: 1vh;\r\n      width: 0.25em;\r\n    }\r\n  }\r\n\r\n  .desk-header-app{\r\n    display: none;\r\n  }\r\n\r\n  .desk-footer-app{\r\n    display: none;\r\n  }\r\n\r\n  .gorgori{\r\n    display: block;\r\n  }\r\n\r\n  .desk-header{\r\n    display: none;\r\n  }\r\n\r\n  .footer-desk{\r\n    display: none;\r\n  }\r\n\r\n  .search_toggle{\r\n    /*position: absolute;\r\n    top: calc(3.5em);*/\r\n\r\n    .conten-abs{\r\n      min-width: 0em;\r\n      width: 100%;\r\n      top: 2.2em;\r\n      border-radius: 0em;\r\n      height: calc(100vh - 5.7em);\r\n      overflow-y: scroll;\r\n      background-color: #00c1f9;\r\n\r\n      .dowi{\r\n        flex-direction: column;\r\n\r\n        .lefti{\r\n          width: 100%;\r\n        }\r\n\r\n        .rigti{\r\n          width: 100%;\r\n          height: 20em;\r\n          overflow: hidden;\r\n        }\r\n      }\r\n    }\r\n\r\n    #search_plugin{\r\n      form{\r\n        .buscainp{\r\n          background-color: #17c2fc;\r\n          border-radius: 0em 0em 0em 0em;\r\n          height: 2.5em;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media(min-width: 992px){\r\n  .asideMenu{\r\n    display: none!important;\r\n    position: relative!important;\r\n    z-index: -1!important;\r\n    visibility: hidden!important;\r\n  }\r\n}","@import '../../swiper-vars.scss';\n@at-root {\n  :root {\n    --swiper-navigation-size: 44px;\n    /*\n  --swiper-navigation-color: var(--swiper-theme-color);\n  */\n  }\n}\n.swiper-button-prev,\n.swiper-button-next {\n  position: absolute;\n  top: 50%;\n  width: calc(var(--swiper-navigation-size) / 44 * 27);\n  height: var(--swiper-navigation-size);\n  margin-top: calc(0px - (var(--swiper-navigation-size) / 2));\n  z-index: 10;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--swiper-navigation-color, var(--swiper-theme-color));\n  &.swiper-button-disabled {\n    opacity: 0.35;\n    cursor: auto;\n    pointer-events: none;\n  }\n  &.swiper-button-hidden {\n    opacity: 0;\n    cursor: auto;\n    pointer-events: none;\n  }\n  .swiper-navigation-disabled & {\n    display: none !important;\n  }\n  &:after {\n    font-family: swiper-icons;\n    font-size: var(--swiper-navigation-size);\n    text-transform: none !important;\n    letter-spacing: 0;\n    font-variant: initial;\n    line-height: 1;\n  }\n}\n.swiper-button-prev,\n.swiper-rtl .swiper-button-next {\n  &:after {\n    content: 'prev';\n  }\n  left: 10px;\n  right: auto;\n}\n.swiper-button-next,\n.swiper-rtl .swiper-button-prev {\n  &:after {\n    content: 'next';\n  }\n  right: 10px;\n  left: auto;\n}\n\n.swiper-button-lock {\n  display: none;\n}\n","@import '../../swiper-vars.scss';\n@at-root {\n  :root {\n    /*\n  --swiper-pagination-color: var(--swiper-theme-color);\n  --swiper-pagination-bullet-size: 8px;\n  --swiper-pagination-bullet-width: 8px;\n  --swiper-pagination-bullet-height: 8px;\n  --swiper-pagination-bullet-inactive-color: #000;\n  --swiper-pagination-bullet-inactive-opacity: 0.2;\n  --swiper-pagination-bullet-opacity: 1;\n  --swiper-pagination-bullet-horizontal-gap: 4px;\n  --swiper-pagination-bullet-vertical-gap: 6px;\n  */\n  }\n}\n.swiper-pagination {\n  position: absolute;\n  text-align: center;\n  transition: 300ms opacity;\n  transform: translate3d(0, 0, 0);\n  z-index: 10;\n  &.swiper-pagination-hidden {\n    opacity: 0;\n  }\n  .swiper-pagination-disabled > &,\n  &.swiper-pagination-disabled {\n    display: none !important;\n  }\n}\n/* Common Styles */\n.swiper-pagination-fraction,\n.swiper-pagination-custom,\n.swiper-horizontal > .swiper-pagination-bullets,\n.swiper-pagination-bullets.swiper-pagination-horizontal {\n  bottom: 10px;\n  left: 0;\n  width: 100%;\n}\n/* Bullets */\n.swiper-pagination-bullets-dynamic {\n  overflow: hidden;\n  font-size: 0;\n  .swiper-pagination-bullet {\n    transform: scale(0.33);\n    position: relative;\n  }\n  .swiper-pagination-bullet-active {\n    transform: scale(1);\n  }\n  .swiper-pagination-bullet-active-main {\n    transform: scale(1);\n  }\n  .swiper-pagination-bullet-active-prev {\n    transform: scale(0.66);\n  }\n  .swiper-pagination-bullet-active-prev-prev {\n    transform: scale(0.33);\n  }\n  .swiper-pagination-bullet-active-next {\n    transform: scale(0.66);\n  }\n  .swiper-pagination-bullet-active-next-next {\n    transform: scale(0.33);\n  }\n}\n.swiper-pagination-bullet {\n  width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));\n  height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));\n  display: inline-block;\n  border-radius: 50%;\n  background: var(--swiper-pagination-bullet-inactive-color, #000);\n  opacity: var(--swiper-pagination-bullet-inactive-opacity, 0.2);\n  @at-root button#{&} {\n    border: none;\n    margin: 0;\n    padding: 0;\n    box-shadow: none;\n    appearance: none;\n  }\n  .swiper-pagination-clickable & {\n    cursor: pointer;\n  }\n\n  &:only-child {\n    display: none !important;\n  }\n}\n.swiper-pagination-bullet-active {\n  opacity: var(--swiper-pagination-bullet-opacity, 1);\n  background: var(--swiper-pagination-color, var(--swiper-theme-color));\n}\n\n.swiper-vertical > .swiper-pagination-bullets,\n.swiper-pagination-vertical.swiper-pagination-bullets {\n  right: 10px;\n  top: 50%;\n  transform: translate3d(0px, -50%, 0);\n  .swiper-pagination-bullet {\n    margin: var(--swiper-pagination-bullet-vertical-gap, 6px) 0;\n    display: block;\n  }\n  &.swiper-pagination-bullets-dynamic {\n    top: 50%;\n    transform: translateY(-50%);\n    width: 8px;\n    .swiper-pagination-bullet {\n      display: inline-block;\n      transition: 200ms transform, 200ms top;\n    }\n  }\n}\n.swiper-horizontal > .swiper-pagination-bullets,\n.swiper-pagination-horizontal.swiper-pagination-bullets {\n  .swiper-pagination-bullet {\n    margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px);\n  }\n  &.swiper-pagination-bullets-dynamic {\n    left: 50%;\n    transform: translateX(-50%);\n    white-space: nowrap;\n    .swiper-pagination-bullet {\n      transition: 200ms transform, 200ms left;\n    }\n  }\n}\n.swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transition: 200ms transform, 200ms right;\n}\n/* Progress */\n.swiper-pagination-progressbar {\n  background: rgba(0, 0, 0, 0.25);\n  position: absolute;\n  .swiper-pagination-progressbar-fill {\n    background: var(--swiper-pagination-color, var(--swiper-theme-color));\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    transform: scale(0);\n    transform-origin: left top;\n  }\n  .swiper-rtl & .swiper-pagination-progressbar-fill {\n    transform-origin: right top;\n  }\n  .swiper-horizontal > &,\n  &.swiper-pagination-horizontal,\n  .swiper-vertical > &.swiper-pagination-progressbar-opposite,\n  &.swiper-pagination-vertical.swiper-pagination-progressbar-opposite {\n    width: 100%;\n    height: 4px;\n    left: 0;\n    top: 0;\n  }\n  .swiper-vertical > &,\n  &.swiper-pagination-vertical,\n  .swiper-horizontal > &.swiper-pagination-progressbar-opposite,\n  &.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite {\n    width: 4px;\n    height: 100%;\n    left: 0;\n    top: 0;\n  }\n}\n.swiper-pagination-lock {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
